import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {Router} from '@angular/router';
import {ProjectService} from '@catcore/services';
import {EntitySchemaService} from '@catcore/services/entity-schema.service';
import {EntitySchemaType} from '@catcore/utils/json-schema/entity-schema-to-json-schema';
import {GenericResourceService} from '@catfeatures/services/generic-resource.service';
import {AvodCatalogBase} from '@catmodels/avod-catalog/avod-catalog-base/avod-catalog-base';
import {ProjectAvodCatalogService} from '@catmodels/avod-catalog/services/project-avod-catalog.service';
import {ModalService} from '@catmodules/widgets/slide-in-modal/services/modal.service';
import {isNullOrUndefined} from 'util';
import {getDirtyFormValues} from "@catcore/utils/form-utils";

@Component({
  selector: 'cat-project-avod-catalog',
  templateUrl: './project-avod-catalog.component.html',
  styleUrls: ['./project-avod-catalog.component.scss'],
})
export class ProjectAvodCatalogComponent extends AvodCatalogBase implements OnInit, OnDestroy {

  @Output() afterDeleteCatalog = new EventEmitter<any>();

  private projectSubscription;
  private project;

  get formIsReady() {
    let isReady = !isNullOrUndefined(this.form);
    isReady = isReady && !isNullOrUndefined(this.schema);
    isReady = isReady && !isNullOrUndefined(this.avodCatalogServiceOptions);
    isReady = isReady && !isNullOrUndefined(this.modeOptions);
    isReady = isReady && !isNullOrUndefined(this.throttleOptions);
    return isReady;
  }

  constructor(private projectService: ProjectService,
              formBuilder: FormBuilder,
              genericService: GenericResourceService,
              modalService: ModalService,
              private router: Router,
              private schemaService: EntitySchemaService,
              private avodCatalogService: ProjectAvodCatalogService) {
    super(formBuilder, genericService, modalService);

    this.service = this.avodCatalogService;
    this.schema = schemaService.getForEntityName(EntitySchemaType['ProjectAvodCatalogs']);
    this.projectSubscription = this
      .projectService
      .getCurrent()
      .subscribe((project: any) => {
        if (!isNullOrUndefined(project)) {
          this.project = project;
        }
      });
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    if (this.projectSubscription) {
      this.projectSubscription.unsubscribe();
    }
  }

  onSubmit() {
    const formValues = getDirtyFormValues(this.form);
    const service = this.genericService.findServiceForResource(this.resourceUri);
    service
      .save(formValues)
      .subscribe(() => {
        console.log('Updated catalog ', this.resourceUri);
      })
    ;
  }

  deleteModel($event) {
    const service = this.genericService.findServiceForResource(this.resourceUri);
    service
      .delete()
      .subscribe(() => {
        this.afterDelete();
      });
  }

  // Down from this point all methods are protected

  protected beforeUpdateForm() {
    this.projectService
      .getAllServices(this.project, 'AVODCatalog').subscribe((services: any[]) => {
      this.updateAvodCatalogServiceOptions(services);
    });

    if (this.schema) {
      this.modeOptions = this.updateChoicesOptions(this.schema.properties.mode.choices);
      this.throttleOptions = this.updateChoicesOptions(this.schema.properties.throttle.choices);
    }

  }

  protected afterDelete() {
    this.resourceUri = '';
    this.form = null;
    this.afterDeleteCatalog.emit();
  }

  protected refresh() {
    const subscription = this.currentAvodCatalogHandler.loadAndGet().subscribe((catalog) => {
      this.formData = catalog;
      subscription.unsubscribe();
    });
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/avod-catalog/components/project-avod-catalog/project-avod-catalog.component.ts